import React from "react";
import {setAuditEnrichProduct} from '../../actions/auditEnrich'
import loadable from "@loadable/component";

export default {
	component: loadable(() => import(/* webpackChunkName: "homepage" */ "./AuditEnrichProduct"),{
		fallback: <div>Loading...</div>
	}),
	clientData: (store,match,location,matchedRoute) => {
		
		const productId = match.params.productId ? match.params.productId : null;
		console.log('productIdIndexOf AuditorProduct',productId);
		return store.dispatch(setAuditEnrichProduct({
			productId
		}));
	}
};
